import { axiosInstance } from "../../axios/axiosInstance";

const MAX_ENTRIES = 60;
const MAX_AGE_MS = 5 * 60 * 1000;

const createCache = () => {
  const entries = new Map();
  return {
    get(key) {
      const entry = entries.get(key);
      if (!entry || Date.now() - entry.at > MAX_AGE_MS) return undefined;
      return entry.value;
    },
    set(key, value) {
      entries.delete(key);
      entries.set(key, { value, at: Date.now() });
      if (entries.size > MAX_ENTRIES) entries.delete(entries.keys().next().value);
    },
    delete: (key) => entries.delete(key),
  };
};

const pageCache = createCache();
const productsCache = createCache();

const cached = (cache, request, key, load) => {
  if (request.userId == null || request.priceCode == null) return load();
  const hit = cache.get(key);
  if (hit) return hit;
  const promise = load().catch((error) => {
    cache.delete(key);
    throw error;
  });
  cache.set(key, promise);
  return promise;
};

const skuKey = (sku) => String(sku ?? "").toLowerCase();

export const getFamilyPage = (request) =>
  cached(pageCache, request, `${request.familyId}|${skuKey(request.sku)}|${request.userId}|${request.priceCode}`, () =>
    axiosInstance.post("ProductNew/HybridInitLoad", request).then((response) => {
      if (!response?.data) throw new Error("Empty product page");
      return response.data;
    }),
  );

export const getFamilyProducts = (request) =>
  cached(productsCache, request, `${request.familyId}|${request.userId}|${request.priceCode}`, () =>
    axiosInstance
      .post("ProductNew/HybridFamilyProductInitLoad", request)
      .then((response) => (Array.isArray(response?.data) ? response.data : [])),
  );

export const findProductBySku = (products, sku) => {
  if (!sku || !Array.isArray(products)) return null;
  const key = skuKey(sku);
  return products.find((item) => skuKey(item?.familyDetails?.sku) === key) ?? null;
};
